<template>
  <div>
    <Form ref="resourceApplicationForm" :model="resourceApplicationForm" :label-width="150">
    <Row>
      <Col span="11">
        <FormItem :label="$t( 'resourceLifecycle.name' )" prop="name">
          <Input v-model="resourceApplicationForm.name" :placeholder="$t( 'resourceLifecycle.pleaseenter' )"/>
        </FormItem>
      </Col>
      <Col span="11">
        <FormItem :label="$t( 'resourceLifecycle.numberofinstances' )" prop="numberOfInstances">
          <InputNumber v-model="resourceApplicationForm.numberOfInstances" @on-change="queryAzureVMPrice" style="width: 100%;"></InputNumber>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem :label="$t( 'resourceLifecycle.username' )" prop="userName">
          <Input v-model="resourceApplicationForm.userName" :placeholder="$t( 'resourceLifecycle.pleaseenter' )"/>
        </FormItem>
      </Col>
      <Col span="11">
        <FormItem :label="$t( 'resourceLifecycle.passwords' )" prop="password">
          <Input v-model="resourceApplicationForm.password" type="password"></Input>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem :label="$t( 'resourceLifecycle.webs' )" prop="vpc">
          <Select v-model="resourceApplicationForm.vpc" filterable>
            <Option :value="item.name" v-for="(item,index) in vpcList" v-bind:key="item.name">{{item.name}}</Option>
          </Select>
        </FormItem>
      </Col>
      <Col span="11">
        <FormItem :label="$t( 'resourceLifecycle.subnet' )" prop="subnet">
          <Select v-model="resourceApplicationForm.subnet" filterable>
            <Option :value="item.name" v-for="item in subnetList" v-bind:key="item.name">{{item.name}}</Option>
          </Select>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem :label="$t( 'resourceLifecycle.automaticdistributionofpublicIP' )" prop="automaticallyAssignPublicIP">
          <Select v-model="resourceApplicationForm.automaticallyAssignPublicIP" filterable>
            <Option :value="item.label" v-for="(item,index) in automaticallyAssignPublicIPList" :key="index">
              {{item.name}}
            </Option>
          </Select>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem :label="$t( 'resourceLifecycle.storageAccounts' )" prop="storageAccount">
          <Select v-model="resourceApplicationForm.storageAccount" filterable>
            <Option :value="item.storageAccountName" v-for="item in storageAccountList"
                    v-bind:key="item.storageAccountName">{{item.storageAccountName}}
            </Option>
          </Select>
        </FormItem>
      </Col>
    </Row>

    <!-- 磁盘 -->
    <Row>
      <Col span="11">
        <FormItem :label="$t( 'resourceLifecycle.oSDiskType' )" prop="diskType">
          <Select v-model="resourceApplicationForm.diskType" filterable>
            <Option :value="item.name" v-for="(item,index) in diskTypeList" v-bind:key="item.name">{{item.name}}
            </Option>
          </Select>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="22">
        <FormItem :label="$t( 'resourceLifecycle.cloudPlatformSpecifications' )">
          <Table :no-data-text="$t('common.noData')" :columns="columns" :data="cloudPlatformSpecificationsDate"></Table>
        </FormItem>
      </Col>
    </Row>

    <!-- 镜像 -->
    <Row>
      <Col span="22">
        <FormItem :label="$t( 'resourceLifecycle.operatingsystem' )">
          <Row :gutter="10">
            <Col span="11">
              <FormItem prop="os">
                <Select v-model="resourceApplicationForm.os" filterable @on-change="listAzureImageVersion">
                  <Option :value="item.id" v-for="(item,index) in osList" v-bind:key="item.id">
                    {{item.name}}
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="11">
              <FormItem prop="mirror">
                <Select v-model="resourceApplicationForm.mirror" filterable>
                  <Option :value="item.name" v-for="(item,index) in mirrorList" v-bind:key="item.name">
                    {{item.name}}
                  </Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="22">
        <FormItem :label="$t( 'resourceLifecycle.tags' )">
          <Row :gutter="10">
            <Col span="11"><label>{{$t('resourceLifecycle.keyupto128characters')}}</label></Col>
            <Col span="11"><label>{{$t('resourceLifecycle.valueupto256characters')}}</label></Col>
          </Row>
          <FormItem v-for="(tag,index) in resourceApplicationForm.tags" :key="index">
            <Row :gutter="10">
              <Col span="11" style="margin-bottom: 20px;">
                <FormItem :prop="'tags.' + index + '.key'"
                          :rules="{type: 'string',pattern:'^(?!Name$)' ,message: '键名不能为Name', trigger: 'blur'}">
                  <Input type="text" v-model="tag.key"></Input>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem>
                  <Input type="text" v-model="tag.value"></Input>
                </FormItem>
              </Col>
              <Col span="2">
                <Button @click="handleRemoveTag(index)">{{$t('resourceLifecycle.delete')}}</Button>
              </Col>
            </Row>
          </FormItem>
          <Row>
            <Col span="22">
              <Button type="dashed" long @click="handleAdd" icon="md-add">{{$t('resourceLifecycle.addTag')}}</Button>
            </Col>
          </Row>
        </FormItem>
      </Col>
    </Row>
    </Form>
  </div>
</template>

<script>
  import {setCookie, getCookie, delCookie} from '../../../../../utils/cookieUtil.js'

  export default {
    name: 'AzureVirtualMachine',
    props: ['azureResourceApplicationBasicInfoForm', 'cost'],
    components: {},
    data() {
      return {
        currentChoose: 0,
        modal_loadings: false,
        addloading: false,
        osList: [],
        mirrorList: [],
        subnetList: [],
        vpcList: [],
        azureVirtualNetworksResult: '',
        securityGroupList: [],
        storageAccountList: [],
        automaticallyAssignPublicIPList: [{
          label: 'true',
          name: this.$t( 'resourceLifecycle.yes' )
        }, {
          label: 'false',
          name: this.$t( 'resourceLifecycle.no' )
        }],
        diskTypeList: [],
        resourceApplicationForm: {
          name: '',
          numberOfInstances: 1,
          calculationSpecifications: '',
          instanceType: '',
          storageAccount: '',
          cpu: '',
          memory: '',
          os: '',
          mirror: '',
          subnet: '',
          vpc: '',
          automaticallyAssignPublicIP: 'true',
          securityGroup: '',
          userName: '',
          password: '',
          diskType: '',
          diskSize: 100,
          tags: [{
            key: '',
            value: ''
          }]
        },
        ruleValidate: {
          name: [
            {required: true, message: this.$t( 'resourceLifecycle.namecannotbeempty' ), trigger: 'blur'}
          ],
          numberOfInstances: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseenterthenumberofinstances' ), trigger: 'blur', type: 'number'}
          ],
          os: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselecttheoperatingsystem' ), trigger: 'change', type: 'number'}
          ],
          mirror: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectamirror' ), trigger: 'change', type: 'number'}
          ],
          subnet: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectsubnet' ), trigger: 'change'}
          ],
          vpc: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectnetwork' ), trigger: 'change'}
          ],
          automaticallyAssignPublicIP: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectAutoAssignPublicIP' ), trigger: 'change'}
          ],
          securityGroup: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectasecuritygroup' ), trigger: 'change'}
          ],
          userName: [
            {required: true, message: this.$t( 'resourceLifecycle.usernamecannotbeempty' ), trigger: 'blur'}
          ],
          password: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseenterapassword' ), trigger: 'blur'}
          ],
          diskType: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectOSDiskType' ), trigger: 'change'}
          ]
        },
        columns: [
          {
            title: this.$t( 'resourceLifecycle.selects' ),
            key: 'vmName',
            width: 70,
            align: 'center',
            render: (h, params) => {
              let vmName = params.row.vmName;
              let cpu = params.row.cpu;
              let memory = params.row.memory;
              let flag = false;
              if (this.resourceApplicationForm.instanceType === vmName) {
                flag = true
              } else {
                flag = false
              }
              let self = this
              return h('div', [
                h('Radio', {
                  props: {
                    value: flag
                  },
                  on: {
                    'on-change': () => {
                      self.resourceApplicationForm.instanceType = vmName;
                      self.resourceApplicationForm.cpu = cpu;
                      self.resourceApplicationForm.memory = memory;
                      self.queryAzureVMPrice();
                    }
                  }
                })
              ])
            }
          },
          {
            title: this.$t( 'resourceLifecycle.models' ),
            key: 'vmName'
          },
          {
            title: this.$t( 'resourceLifecycle.numberofCPUcores' ),
            key: 'cpu'
          },
          {
            title: this.$t( 'resourceLifecycle.memoryGB' ),
            key: 'memory'
          }],
        cloudPlatformSpecificationsDate: []
      }
    },
    mounted: function () {
      // 上传附件接口
      this.actionUrl = process.env.API_ROOT + '/sme/file/uploadFileS3';
    },
    methods: {
      showAll: function () {
        this.getAzureNetworkConfiguration();
        this.queryAzureVolumeType();
        this.listAzureVirtualMachineSizes();
        this.listAzureImage();
        this.queryAzureStorageAccounts();
      },
      //查询Azure EC2 价格
      queryAzureVMPrice: function () {
        this.$api.azurePrice.queryAzureVMPrice({
          "osType": this.resourceApplicationForm.os,
          "duration": this.azureResourceApplicationBasicInfoForm.periodOfUse,
          "region": this.azureResourceApplicationBasicInfoForm.region,
          "lifecycleResourceInstanceDTO": {
            "instanceType": this.resourceApplicationForm.instanceType,
            "cpu": this.resourceApplicationForm.cpu,
            "ram": this.resourceApplicationForm.memory,
            "instanceNumber": this.resourceApplicationForm.numberOfInstances
          }
        })
          .then(res => {
            this.resourceApplicationForm.cost = res.data
            this.$emit('success', this.resourceApplicationForm.cost);
          })
      },
      //获取Azure网络配置
      getAzureNetworkConfiguration: function () {
        this.vpcList = [];
        this.subnetList = [];
        this.resourceApplicationForm.vpc = '';
        this.resourceApplicationForm.subnet = '';
        this.$api.lifecycleResourceApplication.getAzureNetworkConfiguration({
          "accountId": this.azureResourceApplicationBasicInfoForm.accountId,
          "location": this.azureResourceApplicationBasicInfoForm.region,
          "resourceGroupName": this.azureResourceApplicationBasicInfoForm.resourceGroup
        })
          .then(res => {
            if (res.data.azureVirtualNetworksResult == undefined || res.data.azureSubnetResult == undefined) {
              return;
            }
            this.azureVirtualNetworksResult = res.data;
            this.vpcList = this.azureVirtualNetworksResult.azureVirtualNetworksResult.value
            this.subnetList = this.azureVirtualNetworksResult.azureSubnetResult.value
            this.resourceApplicationForm.vpc = this.vpcList[0].name
            this.resourceApplicationForm.subnet = this.subnetList[0].name
          })
      },
      //查询Azure磁盘类型
      queryAzureVolumeType: function () {
        this.$api.lifecycleResourceApplication.queryAzureVolumeType()
          .then(res => {
            this.diskTypeList = res.data;
            this.resourceApplicationForm.diskType = this.diskTypeList[0].name
          })
      },
      //获取Azure虚拟机机型列表
      listAzureVirtualMachineSizes: function () {
        this.$api.lifecycleResourceApplication.listAzureVirtualMachineSizes({
          "accountId": this.azureResourceApplicationBasicInfoForm.accountId,
          "location": this.azureResourceApplicationBasicInfoForm.region
        })
          .then(res => {
            this.cloudPlatformSpecificationsDate = res.data;
          })
      },
      //查询azure平台image类型
      listAzureImage: function () {
        this.$api.lifecycleResourceApplication.listAzureImage()
          .then(res => {
            this.osList = res.data;
            this.resourceApplicationForm.os = this.osList[0].id
            this.listAzureImageVersion();
          })
      },
      //查询azure镜像版本号
      listAzureImageVersion: function () {
        this.$api.lifecycleResourceApplication.listAzureImageVersion({
          "accountId": this.azureResourceApplicationBasicInfoForm.accountId,
          "location": this.azureResourceApplicationBasicInfoForm.region,
          "imageSku": this.resourceApplicationForm.os
        })
          .then(res => {
            this.mirrorList = res.data;
            this.resourceApplicationForm.mirror = this.mirrorList[0].name
          })
      },
      //查询存储账户
      queryAzureStorageAccounts: function () {
        this.$api.lifecycleResourceApplication.queryAzureStorageAccounts({
          "accountId": this.azureResourceApplicationBasicInfoForm.accountId
        })
          .then(res => {
            if (res.data) {
              this.storageAccountList = res.data;
              this.resourceApplicationForm.storageAccount = this.storageAccountList[0].storageAccountName;
            }

          })
      },
      /*********************标签***********************************/
      handleAdd() {
        this.resourceApplicationForm.tags.push({
          value: '',
          key: ''
        })
      },
      handleRemoveTag(index) {
        if (this.resourceApplicationForm.tags.length === 1) {
          this.$Message.warning(this.$t( 'resourceLifecycle.atleastonesubdimensionisrequired' ))
          return
        }
        this.resourceApplicationForm.tags.splice(index, 1)
      }
    }
  }
</script>

<style scoped>
  .resourceApplication-title {
    width: 100%;
    font-size: 13px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 15px 0px 8px 4px;
    font-weight: 600;
    overflow: hidden;
  }

  .ivu-breadcrumb {
    font-size: 13px;
    font-weight: 600;
    color: #515a6e;
  }
</style>




// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_application/azure/virtual_machine/AzureVirtualMachine.vue